// Pure lifecycle for the "awaiting a backend conversational reply" working
// state after a genuine human message in a room. This never fabricates a reply
// — it only decides whether to show an immediate working indicator and when to
// clear it. Ambient cooldown is a BACKEND concern and is never applied here, so
// a human message always enters the lifecycle (never suppressed client-side).

export const REPLY_WAIT = {
  maxMs: 18000,   // stop the working state if no reply materializes
  nudgeMs: 1500,  // first extra refresh after a send (feel responsive)
  nudge2Ms: 3500, // second extra refresh
};

// Begin awaiting a reply for a human send. Returns null (no working state) only
// when there is no room or agents are not enabled — otherwise ALWAYS returns a
// state, regardless of recent ambient activity.
export function startAwaiting({ roomId, agentsEnabled, maxSeq, now = Date.now() }) {
  if (!roomId || !agentsEnabled) return null;
  return { sinceSeq: Number(maxSeq) || 0, until: now + REPLY_WAIT.maxMs };
}

// Resolve (clear) the working state once a NEW agent message arrived after the
// send, or the max wait elapsed.
export function awaitingResolved(awaiting, messages, now = Date.now()) {
  if (!awaiting) return true;
  if (now >= awaiting.until) return true;
  const list = Array.isArray(messages) ? messages : [];
  return list.some((m) => m && m.is_ai === true && typeof m.seq === "number" && m.seq > awaiting.sinceSeq);
}

// Whether to render the working indicator right now.
export function isAwaitingActive(awaiting, messages, now = Date.now()) {
  return !!awaiting && !awaitingResolved(awaiting, messages, now);
}
